interface PermissionsPolicy {
  readonly allowsFeature: (feature: string) => boolean;
}

function isPermissionsPolicy(value: unknown): value is PermissionsPolicy {
  return (
    typeof value === 'object' &&
    value !== null &&
    'allowsFeature' in value &&
    typeof value.allowsFeature === 'function'
  );
}

function readPermissionsPolicy(): unknown {
  if ('permissionsPolicy' in document) {
    return document.permissionsPolicy;
  }

  return 'featurePolicy' in document ? document.featurePolicy : null;
}

export function subscribeToNothing(): () => void {
  return () => undefined;
}

export function isMicrophoneAllowedByPermissionsPolicy(): boolean {
  const policy = readPermissionsPolicy();

  return isPermissionsPolicy(policy)
    ? policy.allowsFeature('microphone')
    : true;
}

export function isMicrophoneAllowedOnServer(): boolean {
  return true;
}
